import { createContext } from 'react';
import { TenderModule } from '@modules/tender-platform/types';
import { Module } from '@common/types';

export const ILSTenderModuleContext = createContext<TenderModule>(Module.TenderOwn);
